import { findAnchor, getFullEdges } from '@common/utils/flow';
import { AnchorType, FullEdge } from '@components/Flow';
import { FieldValidation } from '@components/Flow/Nodes';
import { Command } from '@store/slices';
import { Connection, Edge } from 'reactflow';

export const isConnectable = (anchor: AnchorType, connections: FullEdge[] = []) => {
  const { type, variant } = anchor;

  if (type === 'source') {
    if (variant === 'plugin' && connections?.length > 0) return false;
    if (variant === 'data' || variant === 'condition') return true;
  }

  return true;
};

export const getValidation = (validation: FieldValidation | undefined) => {
  if (validation === FieldValidation.variable) {
    return (value: string) => {
      const formatted = value.replace(/ /g, '_').replace(/[^a-zA-Z0-9_\-]/g, '');
      return formatted.toLowerCase();
    };
  }

  return (value: string) => value;
};

export const isValidConnection = (
  connection: Connection,
  commands: Command[],
  edges: Edge[],
  isInfiniteLoop: (source: string, target: string, commands: Command[], full_edges: FullEdge[]) => boolean
) => {
  try {
    const full_edges = getFullEdges(edges, commands);
    const sourceAnchor = findAnchor(connection.sourceHandle as string, commands);
    const targetAnchor = findAnchor(connection.targetHandle as string, commands);

    const isValidExecutionEdge =
      sourceAnchor?.variant.includes('execution') && targetAnchor?.variant.includes('execution');

    // check if the source variant does not match the target variant (e.g. data -> execution)
    if (sourceAnchor?.variant !== targetAnchor?.variant && !isValidExecutionEdge) return false;

    // check if the edge is connecting to itself
    if (connection.source === connection.target) return false;

    // check if the edge creates an infinite loop
    if (sourceAnchor?.variant.includes('execution') && targetAnchor?.variant.includes('execution')) {
      const isLoop = isInfiniteLoop(connection?.source || '', connection?.target || '', commands, full_edges);
      if (isLoop) return false;
    }

    // checks if the edge already exists
    if (
      full_edges.some(
        (item) =>
          item.source_anchor.id === sourceAnchor.id &&
          item.target_anchor.id === targetAnchor.id &&
          item.edge.source === connection.source &&
          item.edge.target === connection.target
      )
    )
      return false;

    return true;
  } catch (e) {
    return false;
  }
};
